<template>
  <div class="kv-list">
    <div class="block" v-for="(block, index) in blocks" :key="`block${index}`">
      <n-item
        v-for="row in block"
        :label="row.label"
        :value="data[row.prop]"
        :formatter="row.formatter"
        :decorator="row.decorator"
        :key="row.prop"
      />
    </div>
  </div>
</template>

<script>
import NItem from './item.vue';

export default {
  props: {
    blocks: {
      type: [Array, null],
      default: null
    },
    data: {
      type: [Object, null],
      default: () => ({})
    }
  },
  components: {
    NItem
  }
};
</script>

<style lang="scss" scoped>
.kv-list {
  display: flex;
  justify-content: space-between;
  .block {
    margin-bottom: 10px;
  }
}
</style>
